module.exports = __webpack_public_path__ + "img/act-of-emotion-4-mobile.aa3672f7.jpg";